import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto text-center py-10" data-testid="payment-cancel-page">
      <div className="card-editorial p-10 flex flex-col items-center gap-4">
        <span className="eyebrow">Checkout closed</span>
        <h1 className="font-serif text-4xl text-stone-900">No harm done.</h1>
        <p className="text-stone-600 max-w-sm">
          You left before finishing. Cadence is exactly as you left it — ads and all.
        </p>
        <Link to="/premium" className="btn-accent mt-2" data-testid="payment-cancel-retry">
          <ChevronLeft size={16} /> Back to Premium
        </Link>
      </div>
    </div>
  );
}
